import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import ComingSoonCityModal from "./component";
import { toggleLocationPicker } from "../location-picker-popup/actions";
import { setComingSoon } from "../car-list/actions";

const mapStateToProps = ({
    carList: {
        isComingSoon
    },
    cities: {selectedCity},
    user: {
        isLoggedIn,
        userId
    }
}) => ({
    isComingSoon,
    selectedCity,
    isLoggedIn,
    userId
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    toggleLocationPickerConnect: toggleLocationPicker,
    setComingSoonConnect: setComingSoon
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ComingSoonCityModal);
